import React, { useEffect, useState } from "react";
import { Select, Stack, Text, TextInput } from "@mantine/core";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faLock } from '@fortawesome/free-solid-svg-icons';
import VenuesApi from "../../../data/api/venueApi";
import { IVenue } from "../../../types/venue/Venue";

interface VenueSelectorProps {
  label: string;
  value: string | null; // Venue ID
  onChange: (venueId: string | null) => void;
  helpText?: string;
  disabled?: boolean;
}

const VenueSelector: React.FunctionComponent<VenueSelectorProps> = ({
  label,
  value,
  onChange,
  helpText,
  disabled = false,
}) => {
  const [venues, setVenues] = useState<IVenue[]>([]);
  const [loading, setLoading] = useState(false);

  // Load venues
  useEffect(() => {
    setLoading(true);
    VenuesApi.getAllVenues()
      .then(venuesList => {
        setVenues(venuesList);
      })
      .catch(error => {
        console.error("Failed to load venues:", error);
      })
      .finally(() => {
        setLoading(false);
      });
  }, []);

  const handleChange = (selectedValue: string | null) => {
    onChange(selectedValue === "" ? null : selectedValue);
  };

  const data = [
    { value: "", label: "-- No Home Venue --" },
    ...venues.map(venue => ({
      value: venue._id,
      label: venue.name
    }))
  ];

  return (
    <Stack gap="sm">
      <Text size="sm" fw={500} className={disabled ? 'text-muted' : ''}>
        {label}
        {disabled && <FontAwesomeIcon icon={faLock} className="ms-2 text-muted" />}
      </Text>
      {helpText && <div className="text-muted small mb-2">{helpText}</div>}
      
      <Select
        value={value || ""}
        onChange={handleChange}
        disabled={disabled || loading}
        data={data}
      />
      
      {loading && (
        <div className="text-muted small mt-1">Loading venues...</div>
      )}
    </Stack>
  );
};

export default VenueSelector;
